import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type TerminalBrowserIconProps = IconProps

const TerminalBrowserIcon = forwardRef<SVGSVGElement, TerminalBrowserIconProps>(
  (props: TerminalBrowserIconProps, ref) => (
    <Icon {...props} ref={ref}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M22 9H2m4 8.5L8.5 15 6 12.5m5 5h4M2 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 21 5.12 21 6.8 21h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.72 22 17.88 22 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C19.72 3 18.88 3 17.2 3H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 5.28 2 6.12 2 7.8Z"
        fill="none"
      ></path>
    </Icon>
  ),
)

TerminalBrowserIcon.displayName = 'TerminalBrowserIcon'
TerminalBrowserIcon.defaultProps = iconDefaultProps

export type { TerminalBrowserIconProps }
export { TerminalBrowserIcon }
